export default function AboutSection() {
  const pillars = [
    {
      icon: 'ri-shield-check-line',
      title: 'Security First',
      desc: 'Every product is engineered with privacy and security as the core design principle.',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'iOS Native',
      desc: 'We build exclusively for the iOS platform, delivering deeply optimized native experiences.',
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'Expert Engineering',
      desc: 'Our team combines years of mobile development expertise with cutting-edge technology.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'User-Centric',
      desc: 'Intuitive interfaces and smooth performance are the benchmark for everything we ship.',
    },
  ];

  return (
    <section id="about" className="bg-[#f8f9fa] py-28 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 text-xs font-semibold tracking-widest uppercase rounded-full px-4 py-1.5 mb-6">
              About Us
            </div>
            <h2 className="text-4xl xl:text-5xl font-extrabold text-[#0c0e12] leading-tight mb-6">
              A Team of Experts<br />
              <span className="text-emerald-500">Shaping the Future</span><br />
              of iOS Security
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed mb-6">
              IDEA D.O.O. is a dedicated software development company based in North Macedonia,
              specializing in building modern, high-quality applications for the iOS platform.
              Our focus on mobile security and device optimization allows us to create tools
              that genuinely make a difference in users&apos; everyday digital lives.
            </p>
            <p className="text-gray-500 text-lg leading-relaxed">
              From inception to App Store deployment, we handle every phase of product development
              with precision and passion — ensuring that each release meets the highest standards
              of performance, security, and design excellence.
            </p>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden w-full h-[420px]">
              <img
                src="https://public.readdy.ai/ai/img_res/1fad327ef7ef32edbc750ec974cd30f3.jpg"
                alt="IDEA D.O.O. team workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-5 -left-5 bg-[#0c0e12] rounded-xl px-6 py-4 shadow-xl">
              <p className="text-emerald-400 text-2xl font-extrabold">5+</p>
              <p className="text-white/60 text-xs mt-0.5 whitespace-nowrap">Years of Experience</p>
            </div>
          </div>
        </div>

        {/* Pillars */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-20">
          {pillars.map((p) => (
            <div key={p.title} className="bg-white rounded-xl p-6 border border-gray-100">
              <div className="w-11 h-11 flex items-center justify-center bg-emerald-50 rounded-lg mb-4">
                <i className={`${p.icon} text-xl text-emerald-600`} />
              </div>
              <h4 className="font-bold text-[#0c0e12] text-base mb-2">{p.title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
